"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var storage = __importStar(require("./storage"));
require("whatwg-fetch");
exports.serialize = function (obj) {
    if (obj === void 0) { obj = {}; }
    return Object.keys(obj)
        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]); })
        .join('&');
};
exports.json = function (fn) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fn.apply(void 0, __spread(args))];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.json()];
            }
        });
    });
};
var bearerResponse = function (response) {
    response.then(function (data) {
        if (data.ok && !lodash_1.isEmpty(data.headers.get('bearer'))) {
            storage.put('token', data.headers.get('bearer'));
        }
    });
    return response;
};
var handleErrorsDefault = function (response) { return __awaiter(_this, void 0, void 0, function () {
    var r;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, response];
            case 1:
                r = _a.sent();
                if (!r.ok) {
                    throw new Error(r.status);
                }
                return [2 /*return*/, response];
        }
    });
}); };
exports.defaultOptions = {
    credentials: 'same-origin',
};
exports.default = (function (url, _a) {
    if (_a === void 0) { _a = {}; }
    var params = _a.params, context = _a.context, checkToken = _a.checkToken, handleErrors = _a.handleErrors, rest = __rest(_a, ["params", "context", "checkToken", "handleErrors"]);
    var token = storage.get('token');
    var options = __assign({}, exports.defaultOptions, rest);
    var headers = lodash_1.get(options, 'headers') || new Headers();
    var checker = checkToken instanceof Function ? checkToken : function (token) { return true; };
    if (token && token !== 'null' && checker(token)) {
        headers.set('Authorization', "Bearer " + token);
        headers.set('Authorizationjwt', "Bearer " + token);
        try {
            var customHeaders = storage.get('uas-fetch-headers');
            if (customHeaders) {
                var parsed_1 = JSON.parse(customHeaders);
                Object.keys(parsed_1).forEach(function (key) { return headers.set(key, parsed_1[key]); });
            }
        }
        catch (_b) { }
    }
    var queryString = exports.serialize(params);
    var questionMark = lodash_1.isEmpty(queryString) ? '' : '?';
    var errorsHandler = handleErrors instanceof Function ? handleErrors : handleErrorsDefault;
    return errorsHandler(bearerResponse(fetch("" + lodash_1.trimEnd(context, '/') + url + questionMark + queryString, __assign({}, options, { headers: headers }))));
});
//# sourceMappingURL=fetch.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/utils/fetch.js
// module id = 363
// module chunks = 0